import generateUtilityClasses from'@mui/utils/generateUtilityClasses';const boxClasses=generateUtilityClasses('MuiBox',['root']);export default boxClasses;